module.exports = __webpack_public_path__ + "assets/img/btn-view-55128f45.png";